import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Botao, EstadoVazio } from '../egora';
import './casca.css';

/** Endereço que não existe dentro da casca. Mostra o caminho de volta, em vez de sumir em silêncio. */
export default function PaginaNaoEncontrada() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="sj casca-pagina">
      <h1 className="sj-oculto">Página não encontrada</h1>
      <EstadoVazio
        icone="explore_off"
        titulo="Esta página não existe"
        texto="O endereço pode ter mudado ou o link foi copiado pela metade. Seus dados continuam onde estavam."
        acao={<Botao icone="home" onClick={() => navigate('/')}>Ir para a Home</Botao>}
      />
      <p className="casca-pagina__endereco">
        Endereço procurado: <code>{pathname}</code>
      </p>
    </div>
  );
}
